module.exports = __webpack_public_path__ + "static/img/pb_rab.b3c0094.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customers/pb_rab.png
// module id = ik7L
// module chunks = 0